import React from "react";
import { SimpleField } from "@Components/FormFields/SimpleField";
import RadioGroup from "@overrides_venia/venia-ui/components/RadioGroup/radioGroup";
import { useIntl } from "react-intl";
export var GenderField = _ref => {
  var {
    showLabel,
    borderClass,
    backgroundClass = "uk-background-creamer",
    label,
    required = false,
    showInvalid
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(SimpleField, {
    showLabel: showLabel,
    label: label ? label : formatMessage({
      id: "input.gender"
    }),
    name: "gender",
    required: required,
    backgroundClass: backgroundClass,
    borderClass: borderClass,
    showInvalid: showInvalid,
    children: /*#__PURE__*/React.createElement(RadioGroup, {
      isVertical: false,
      field: "gender",
      items: [{
        label: "M",
        value: 1
      }, {
        label: "F",
        value: 2
      }, {
        label: "Non binario",
        value: 3
      }],
      required: true
    })
  });
};